module.exports = __webpack_public_path__ + "src/assets/img/engine_six.9f91ff21.svg";